var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddMilestone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--grey-darken-33)",
  fillRule: "evenodd",
  d: "M21.138 12c0-5.522-4.564-10-10.192-10S.753 6.478.753 12s4.564 10 10.193 10a10.24 10.24 0 0 0 7.202-2.933l-1.608-1.578a7.94 7.94 0 0 1-5.594 2.289c-4.383 0-7.928-3.478-7.928-7.778s3.545-7.778 7.928-7.778S18.873 7.7 18.873 12h-2.028c-.505 0-.757.6-.4.949l3.202 3.133a.574.574 0 0 0 .804-.003l3.138-3.134c.352-.351.099-.945-.403-.945z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--grey-darken-33)",
  fillRule: "evenodd",
  d: "M11.713 11.02h2.937v1.96h-2.938v2.936H9.755V12.98H6.817v-1.958h2.937V8.084h1.959z",
  clipRule: "evenodd"
})));
export default SvgAddMilestone;